export const DEFAULT_SUFFIX = '...';

export default function truncate(string: string, maxLength: number, suffix = DEFAULT_SUFFIX) {
  if (string.length <= maxLength) return string;

  return string.slice(0, maxLength - suffix.length) + suffix;
}
